import { getLogger } from '@ravago/shared/logging/client';
import { TypeLanguagesFields } from '@ravago/shared/page-data/models/contentful-generated';
import { NormalizedCollection, NormalizedLanguage } from '@ravago/shared/page-data/models/contentful-mapped';
import { ContentfulUtils } from '@ravago/shared/page-data/utils/contentful';
import { DataMapperUtils } from '@ravago/shared/page-data/utils/data-mapper';
import { validateAndFilterLanguagesEntries } from '@ravago/shared/page-data/validators';

import { ContentfulClientApi } from 'contentful';

export class LanguageUtils {
  static async getLanguages(contentfulClientApi: ContentfulClientApi, locale: string): Promise<NormalizedCollection<NormalizedLanguage>> {
    try {
      const entries = await contentfulClientApi.getEntries<TypeLanguagesFields>({ content_type: 'languages', locale, limit: 1000, include: 1 });

      if (!entries.total) return ContentfulUtils.getDefaultCollection();

      const validEntries = validateAndFilterLanguagesEntries(entries.items);

      entries.items = validEntries;

      return DataMapperUtils.normalizeContentfulCollection<NormalizedCollection<NormalizedLanguage>>(entries, DataMapperUtils.normalizeContentfulLanguage);
    } catch (error) {
      getLogger().error(error instanceof Error ? error.message : 'Unknown error occurred.');

      return ContentfulUtils.getDefaultCollection();
    }
  }
}
